export default __webpack_public_path__ + "static/banner-media-release-2020-08-94dedf56e7d19451b55fee8739beeef1.jpg";